import * as Dialog from '@radix-ui/react-dialog';
import { motion } from 'motion/react';
import { twMerge } from 'tailwind-merge';

export type OverlayProps = Dialog.DialogOverlayProps;

export function Overlay({ className, ...props }: OverlayProps) {
  return (
    <Dialog.Overlay {...props} asChild>
      <motion.div
        className={twMerge(
          'fixed inset-0 z-50 bg-[rgba(14,38,69,0.77)]',
          className,
        )}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      />
    </Dialog.Overlay>
  );
}
